import Vue from 'vue';
import Vuex from 'vuex';
import threeSteps from './modules/threeSteps';
import feed from './modules/feed.module';
import user from './modules/user.module';
import comment from './modules/comment.module';
import oilGasFinder from './modules/oil-gas-finder.module';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    threeSteps,
    feed,
    user,
    comment,
    oilGasFinder,
  },
  strict: debug,
});
